import React from 'react'
import { MyImage } from '../ui/MyImage'
import classNames from 'classnames'
import { CDNImage } from './CDNImage'

export const MyAvatar: React.FC<{
  image: string
  size: number
  style?: React.CSSProperties
  hiddenIcon?: boolean
  className?: string
  iconClassName?: string
  isVip?: boolean | null
}> = ({
  image,
  size,
  className,
  style,
  hiddenIcon = false,
  isVip,
  iconClassName,
}) => {
  return (
    <div
      style={{ height: size, width: size, ...style }}
      className={classNames('relative', className)}
    >
      <MyImage
        className="w-full h-full rounded-[50%]"
        src={image}
        tag="v400"
        dark
        alt=""
      />
      {!hiddenIcon && isVip && (
        <div
          className={classNames(
            'absolute -bottom-[2px] -right-[3px] w-4 h-4',
            iconClassName
          )}
        >
          <CDNImage
            className="w-full h-full"
            src="/images/icons/vip-icon.svg"
          />
        </div>
      )}
    </div>
  )
}
